import React, { useEffect, useState } from 'react'
import "./Users.css";
//import { useNavigate } from 'react-router-dom'
import { usePreload } from '../hooks/usePreload';
import { useUser } from '../hooks/useUser';
import { userApi } from '../api/user';
import { useAppDispatch } from '../redux/hooks';
import { fetchPreload } from '../redux/slices/preloadSlice';
import Header from './Header';
import { ExternalUserType } from 'types';

const Users: React.FC = () => {
  const queryParams = new URLSearchParams(location.search);
  const lla = queryParams.get("lla"); // LiveLet admin page = 1
  const userEditToken = queryParams.get("uet");

  const preload = usePreload();
  const users = preload?.users;
  const cards = preload?.cards;
  const user = useUser();
  const dispatch = useAppDispatch();
  const [fetchedUsers, setFetchedUsers] = useState<ExternalUserType[] | null>(null);
//  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
        const response = await fetch(`${baseUrl}/api/users-list`);
        const data = await response.json();

        if (data.success && Array.isArray(data.data)) {
          setFetchedUsers(data.data);
        } else {
          console.error("Invalid data format:", data);
        }
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };

    fetchUsers();
  }, []);

  // Compare users and log inactive ones
  useEffect(() => {
    if (!users || !users.length || !fetchedUsers || !fetchedUsers.length) return;
  
    const updateInactiveUsers = async () => {
      const fetchedUserIds = new Set(fetchedUsers.map((u) => u.id));

      const usersToDeactivate = users.filter(user => user.externalUserKey && !fetchedUserIds.has(user.externalUserKey) && user.isActive);
      const usersToAdd = fetchedUsers.filter(user => !users.find(u => u.externalUserKey === user.id));
  
      if (usersToDeactivate.length === 0 && usersToAdd.length === 0) return;
  
      console.log("Users being set as inactive:", usersToDeactivate);
      console.log("Users being added:", usersToAdd);
  
      try {
        // Wait for all users to be updated before proceeding
        await Promise.all(usersToDeactivate.map(user => user.userKey ? userApi.activateUser(user.userKey, false) : Promise.resolve()));
        await Promise.all(usersToAdd.map(user => userApi.addUser(user.id, user.first_name, user.last_name)));
  
        console.log("All users updated, fetching new data...");
        dispatch(fetchPreload());
      } catch (error) {
        console.error("Error updating user statuses:", error);
      }
    };
  
    updateInactiveUsers();
  }, [users, fetchedUsers, dispatch]);
  
  async function handleSave(targetUser: any, role: string, status: boolean) {
    if (!user.userKey || !user.userToken || status == null || status == undefined) return;
    // console.log(selectedUser);
    const statusNumber = status ? 1 : 0;
    try {
      await userApi.editUser(targetUser.userKey, role, statusNumber, userEditToken || "");
      dispatch(fetchPreload());
    } catch (error) {
      console.error("Failed to edit user or fetch updated data:", error);
    }
  };

  const usersList = users
    ?.filter(usr => usr.externalUserKey)
    .sort((a, b) => {
      if (a.externalUserKey && b.externalUserKey) {
        return a.externalUserKey > b.externalUserKey ? 1 : -1;
      }
      return 0;
    })
    .map((user, userIndex) => {

    const userCard = cards?.find(card => card.ownerKey == user.userKey);
    const hasCard = Boolean(userCard);

    const roles = [
      { label: "admin", isChecked: user.isAdmin },
      /*{ label: "editor", isChecked: user.isEditor },*/
      /*{ label: "creator", isChecked: user.isCreator },*/
    ];

    const roleChecks = roles.map((role, index) => (
      <input key={index} type="checkbox" onChange={() => { handleSave(user, role.label, !role.isChecked) }} checked={!!role.isChecked} className="role-check" />
    ));

    const systemName = (Boolean(user.lastName) || Boolean(user.firstName)) ? `${user.lastName || ""}, ${user.firstName || ""}` : null;
    const cardName = userCard ? `${userCard.content?.lastName?.[0]?.content ?? ""} ${userCard.content?.firstName?.[0]?.content ?? ""}` : null;
    const displayedName = (systemName && cardName) ? `${systemName} (${cardName})` : Boolean(systemName) ? systemName : Boolean(cardName) ? cardName : "No name";

    return (
      <div key={user.userKey} className={`userListRow userListRow-top${userIndex%2 === 0 ? " bg-primary-gray" : ""}`}>
        <span className="userElement">{user.employeeId}</span>
        <span className="userElement" style={{display: "flex", justifyContent: "center"}}>{hasCard ? "✔" : "-"}</span>
        <span className="userElement">{displayedName}</span>
        {roleChecks}
      </div>
    );

  });

  return (
    <div className="users-container p-2">
      {lla == "1" ? null : <Header /> }
      <div className='flex mb-6 md:mb-6'>
        <h1 className='text-3xl md:text-2xl font-bold'>ユーザー</h1>
      </div>
      {/* <span style={{ display: "flex" }}>Number of users: {users?.length}</span> */}
      <div className="userListContainer drop-shadow-md">
        <div className="userListRow-top" style={{ backgroundColor: "#fff" }}>
          <span className="userElement">従業員ID</span>
          <span className="userElement">名刺あり</span>
          <span className="userElement">氏名</span>
          <span className="userElement">管理者権限</span>
          {/*<span className="userElement">編集権限</span>*/}
          {/*<span className="userElement">作成権限</span>*/}
        </div>
        <div className='bg-white p-1'>
          {usersList}
        </div>
      </div>
    </div>
  )
}

export default Users
